export const EMPOWER_MODULE='EMPOWER_MODULE';
export const EMPOWER_REPORT_PAGE = `${EMPOWER_MODULE}_REPORT_PAGE`;
export const EMPOWER_REPORT_PAGE_MODERN_LIFE = `${EMPOWER_MODULE}_REPORT_PAGE_MODERN_LIFE`;
export const EMPOWER_REPORT_PAGE_GAMMING = `${EMPOWER_MODULE}_REPORT_PAGE_GAMMING`;
export const EMPOWER_REPORT_EXPORT = `${EMPOWER_MODULE}_REPORT_EXPORT`;
export const PPT = `PPT`;
export const PDF = `PDF`;
